import type React from 'react';

import classNames from 'classnames';

import type { AssetsApprovalBySchema } from '@iconik-io/iconik-api/src/services/assets';
import { Icon } from '@iconik-io/uad';

import TooltipTrigger from '../../tooltip_trigger/tooltip_trigger';

import styles from '../asset_approval_status_detailed.module.css';

const FailureStatuses: React.FC<{
  rejectedBy: AssetsApprovalBySchema[];
  rejectedByUser: boolean;
}> = ({ rejectedBy, rejectedByUser }) => {
  const statuses = [];

  if (rejectedBy.length > 0) {
    statuses.push(
      <div key="rejected-status" className={styles.status_content}>
        <TooltipTrigger
          tooltipText={rejectedByUser ? 'Rejected by you' : 'Rejected'}
          key="reject-status"
          placement="bottom"
          componentProps={{
            role: 'status',
            'aria-label': rejectedByUser ? 'Rejected by you' : 'Rejected',
          }}
        >
          <div className={styles.status_icon}>
            <Icon name={rejectedByUser ? 'ra_rejected_by_me' : 'ra_rejected'} />
          </div>
        </TooltipTrigger>
        {rejectedBy.length > 1 ? (
          <div className={styles.counter}>{rejectedBy.length}</div>
        ) : null}
      </div>,
    );
  }

  if (statuses.length > 0) {
    return (
      <div className={classNames(styles.status_fail, styles.status)}>
        {statuses}
      </div>
    );
  }
  return null;
};

export default FailureStatuses;
